import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

import { useEffect, useRef, useState } from "react";

export const useBuTypeNameByBuId = (buId) => {
  const [buTypeName, setBuTypeName] = useState("");
  const [loading, setLoading] = useState(false);

  // Prevent state update on unmounted component
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    if (!buId) {
      setBuTypeName("");
      return;
    }

    const fetchData = async () => {
      setLoading(true);

      try {
        /** 1️⃣ Fetch APIs in parallel */
        const [buList, buTypeList] = await Promise.all([
          fetchAllPromisedData(endpoint.businessArea.getAllActiveV2),
          fetchAllPromisedData(endpoint.businessType.getAllActiveUnitType),
        ]);

        /** 2️⃣ Validate responses */
        if (!Array.isArray(buList) || !Array.isArray(buTypeList)) {
          throw new Error("Invalid API response");
        }

        /** 3️⃣ Find BU Type ID */
        const buTypeId = buList.find(
          item => item?.businessAreaDispValue === buId
        )?.businessUnitTypeId?.[0];

        if (!buTypeId) {
          if (isMountedRef.current) setBuTypeName("");
          return;
        }

        /** 4️⃣ Find BU Type Name */
        const buTypeName =
          buTypeList.find(item => item?.id === buTypeId)
            ?.businessUnitTypeDispValue || "-";

        if (isMountedRef.current) {
          setBuTypeName(buTypeName);
        }
      } catch (err) {
        if (isMountedRef.current) {
          failureToast(err?.message || "Something went wrong");
          setBuTypeName("");
        }
      } finally {
        if (isMountedRef.current) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMountedRef.current = false;
    };
  }, [buId]);

  return { buTypeName, loading };
};
